import React from 'react';



export class TimerShown extends React.Component {



  render() {
    return (
      <div>
        <h1>{this.props.message}</h1>
        <div className="row">

          <div className="col col-centered card">
            <h1>{this.props.days}</h1>
            <h4>{this.props.dayText}</h4>
          </div>
          <div className="col col-centered card">
            <h1>{this.props.hours}</h1>
            <h4>{this.props.hourText}</h4>
          </div>
          <div className="col col-centered card">
            <h1>{this.props.minutes}</h1>
            <h4>{this.props.minuteText}</h4>
          </div>
          <div className="col col-centered card">
            <h1>{this.props.seconds}</h1>
            <h4>{this.props.secondText}</h4>
          </div>
        </div>
      </div>
    )

  }
}


// WEBPACK FOOTER //
// ./src/Components/App/TimerShown.js